import { renderToStaticMarkup } from 'react-dom/server';
import { t } from 'i18next';
import classes from 'global.module.css';
import { BloodPressureItem } from 'models/bloodpressure';
import { LabelValueProps } from 'models/general';
import styles from './BloodPressure.module.css';

interface ChartTooltipProps {
  date?: string;
  classification?: BloodPressureItem['classification'];
  tooltipData?: LabelValueProps[];
}

export const chartTooltip = ({ date, classification, tooltipData }: ChartTooltipProps) => {
  const { alignMiddle, severityCircle } = styles;

  return renderToStaticMarkup(
    <table className={classes.chartTooltip}>
      <div>
        <tr>
          <th colSpan={2}>
            <div>
              {date && <span className={alignMiddle}>{date}</span>}
              {classification && (
                <div className={alignMiddle} style={{ color: classification?.color }}>
                  <span className={severityCircle} style={{ backgroundColor: classification?.color }} />
                  {t(`severity_${classification?.label}`)}
                </div>
              )}
            </div>
          </th>
        </tr>
        {tooltipData?.map((info, index) => (
          <tr key={`${info}-${index}`}>
            <td>{info.label}</td>
            <td
              style={{
                wordBreak: 'break-word',
                whiteSpace: 'normal',
              }}
            >
              {info.value}
            </td>
          </tr>
        ))}
      </div>
    </table>,
  );
};
